
export default {
  head() {
    return {
      title: 'Dúvidas Frequentes',
    }
  },
}
